import React from 'react';
import { useTranslation } from 'react-i18next';
import { Upload, Settings, Download } from 'lucide-react';

const ProcessFlow: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto mb-32">
      <h2 className="text-center mb-12">{t('process.heading')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="process-container">
          <div className="process-icon-container">
            <Upload className="process-icon" size={24} aria-hidden="true" />
          </div>
          <div className="process-step">
            <h3 className="mb-1">{t('process.upload.title')}</h3>
            <p>{t('process.upload.description')}</p>
          </div>
        </div>
        <div className="process-container">
          <div className="process-icon-container">
            <Settings className="process-icon" size={24} aria-hidden="true" />
          </div>
          <div className="process-step">
            <h3 className="mb-1">{t('process.configure.title')}</h3>
            <p>{t('process.configure.description')}</p>
          </div>
        </div>
        <div className="process-container">
          <div className="process-icon-container">
            <Download className="process-icon" size={24} aria-hidden="true" />
          </div>
          <div className="process-step">
            <h3 className="mb-1">{t('process.download.title')}</h3>
            <p>{t('process.download.description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessFlow;